import { isProd } from '@src/types/constants'
import type { InternalAxiosRequestConfig } from 'axios'
import { getSimulatedDate } from './DateTimeProvider'

export const SIMULATED_DATE_HEADER = 'X-Simulated-Date'

/**
 * Carries the simulated calendar day (`YYYY-MM-DD`) to the API on every call while an
 * override is active. The API grafts the real Eastern time of day onto it.
 */
export const simulatedDateRequestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const simulatedDate = getSimulatedDate()
  if (!isProd && simulatedDate !== null) {
    config.headers.set(SIMULATED_DATE_HEADER, simulatedDate.toString())
  }
  return config
}
